/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Memory_Enabled_DescriptionInputs */



/**
* | output |
* | --- |
* | "When off, nothing is added to your chats. Your saved entries stay here." |
*
* @param {Memory_Enabled_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const memory_enabled_description = /** @type {((inputs?: Memory_Enabled_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Memory_Enabled_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wenn deaktiviert, wird deinen Chats nichts hinzugefügt. Deine Einträge bleiben hier gespeichert.")
	return /** @type {LocalizedString} */ ("When off, nothing is added to your chats. Your saved entries stay here.")
});